module.exports = __webpack_public_path__ + "img/kurir-wheel-2.96417ea5.png";